const ProhibitionIcon = ({
  color = '#231E21',
  width = '45',
  height = '44',
  opacity = '0.8',
}) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M22.6456 40.3334C32.6657 40.3334 40.7887 32.1253 40.7887 22.0001C40.7887 11.8749 32.6657 3.66675 22.6456 3.66675C12.6254 3.66675 4.50244 11.8749 4.50244 22.0001C4.50244 32.1253 12.6254 40.3334 22.6456 40.3334Z"
          stroke={color}
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.81885 9.03784L35.4732 34.9612"
          stroke={color}
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  )
}

export default ProhibitionIcon
